"use client";

import React from 'react';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { FileSignature } from 'lucide-react';

type Props = {
  onContinue: () => void;
}

// Окно 1 «Требуется ваше согласие».
export default function ConsentIntroStep({ onContinue }: Props)
{
  return (
    <>
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <FileSignature className="h-5 w-5" />
          Требуется ваше согласие
        </DialogTitle>
        <DialogDescription>
          Чтобы загружать фотографии в фотобанк, нужно один раз подписать согласие
          на передачу медиа материалов.
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-3 text-sm text-muted-foreground">
        <p>
          Согласие подписывается электронно через сервис «Подпислон» и действует
          бессрочно — повторно подписывать его не потребуется.
        </p>
        <p>
          Сначала заполните реквизиты: по ним формируется текст документа. Паспортные
          данные и ИНН нужны только для документа и не публикуются в фотобанке.
        </p>
      </div>

      <DialogFooter>
        <Button onClick={onContinue} className="w-full sm:w-auto">
          Заполнить реквизиты
        </Button>
      </DialogFooter>
    </>
  );
}
